module.exports = __webpack_public_path__ + "static/media/financing.1721d5ff.svg";